import React, { useState, useEffect } from 'react';
import CommentCard from '../Cards/CommentCard';
import Modal from 'react-modal';
import { useMsal } from '@azure/msal-react';
import { postComment, getCommentCards } from '../../api';
import Legend from '../Legend';

const customStyles = {
  content: {
    width: '450px',
    height: '450px',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    overflow: 'auto',
    WebkitOverflowScrolling: 'touch',
    borderRadius: '8px',
  },
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.75)',
  },
};

const rootElement = document.getElementById('root');
Modal.setAppElement(rootElement);

const Section = (props) => {
  const { instance } = useMsal();
  const account = instance.getActiveAccount();
  const [selectedText, setSelectedText] = useState('');
  const [commentModalOpen, setCommentModalOpen] = useState(false);
  const [comment, setComment] = useState('');
  const [commentLabel, setCommentLabel] = useState('');
  const [hideComments, setHideComments] = useState(false);
  const [referralResultId, setReferralResultId] = useState('');

  const handleSelectionChange = (e) => {
    if (e.target.activeElement.classList.contains('noselect')) {
      return;
    }
    var stext = '';
    var id = '';
    if (window.getSelection().toString() !== '') {
      var s = window.getSelection();
      id = s.baseNode.parentElement.parentElement.parentElement.id;
      stext = window.getSelection().toString();
      if (stext.includes('\n')) {
        stext = stext.split('\n')[2];
      }
      setSelectedText(stext);
      setCommentLabel(
        window.getSelection().anchorNode.parentElement.parentElement.children[0]
          .innerText
      );
      setReferralResultId(id);
    } else {
      setSelectedText('');
    }
  };

  const handleAddComment = async () => {
    const vm = {
      userName: account.username,
      comment: comment,
      highlightedText: selectedText,
      sectionText: commentLabel,
      referralId: props.referralId,
      fileName: props.selectedFile,
      referralResultId: referralResultId,
    };
    const resp = await postComment(vm);
    if (resp) {
      var resp2 = await getCommentCards(props.referralId, props.selectedFile);

      setComment('');
      setCommentModalOpen(false);
      highlightCommentedText(resp2.commentCards);
      props.updateCards(resp2.commentCards);
    }
  };

  const handleAddHiglight = async () => {
    const vm = {
      userName: account.username,
      comment: '',
      highlightedText: selectedText,
      sectionText: commentLabel,
      referralId: props.referralId,
      fileName: props.selectedFile,
      referralResultId: referralResultId,
    };
    const resp = await postComment(vm);

    if (resp) {
      var resp2 = await getCommentCards(props.referralId, props.selectedFile);
      if (resp2) {
        setComment('');
        highlightCommentedText(resp2.commentCards);
        props.updateCards(resp2.commentCards);
      }
    }
  };

  const highlightText = (text, comment, referralResultId) => {
    var labelArea = document.getElementById(referralResultId);
    var inputText = labelArea;
    var innerHTML = inputText.innerHTML;

    var index = innerHTML.indexOf(text); // where the highlighted text starts

    if (index >= 0) {
      if (!labelArea.querySelector('.commented')) {
        if (comment !== '') {
          innerHTML =
            /// 111
            innerHTML.substring(0, index) +
            "<span class='commented highlight'>" +
            innerHTML.substring(index, index + text.length) +
            '</span>' +
            innerHTML.substring(index + text.length);
          inputText.innerHTML = innerHTML;
        } else {
          innerHTML =
            innerHTML.substring(0, index) +
            "<span class='highlighted' >" +
            innerHTML.substring(index, index + text.length) +
            '</span>' +
            innerHTML.substring(index + text.length);
          inputText.innerHTML = innerHTML;
        }
      }
    }
  };

  const highlightCommentedText = (cards) => {
    // Function to check if the element is rendered
    const isElementRendered = (id) => document.getElementById(id) !== null;

    // Function to clear previous highlights
    const clearPreviousHighlights = () => {
      document.querySelectorAll('.commented').forEach((element) => {
        const parent = element.parentNode;
        while (element.firstChild) {
          parent.insertBefore(element.firstChild, element);
        }
        parent.removeChild(element);
      });
    };

    // Function to apply new highlights
    const applyHighlights = () => {
      cards?.forEach((card) => {
        if (isElementRendered(card.referralResultId)) {
          highlightText(
            card.highlightedText,
            card.comment,
            card.referralResultId
          );
        }
      });
    };
    // Clear previous highlights
    clearPreviousHighlights();

    // Apply new highlights
    applyHighlights();
  };

  useEffect(() => {
    document.onselectionchange = handleSelectionChange;
    document.onmouseup = () => {
      var arr = Array.prototype.slice.call(
        document.getElementsByClassName('form-field')
      );
      arr.forEach((ele) => {
        ele.classList.remove('no-select');
      });
    };

    return () => {
      // Cleanup
      document.onmouseup = null;
      document.onselectionchange = null;
    };
  }, []);

  useEffect(() => {
    // Function to handle the highlighting
    const handleHighlighting = () => {
      if (document.readyState === 'complete') {
        highlightCommentedText(props.commentCards);
      } else {
        window.addEventListener('load', () => {
          highlightCommentedText(props.commentCards);
        });
      }
    };

    handleHighlighting();

    // Cleanup
    return () => {
      window.removeEventListener('load', handleHighlighting);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.commentCards]);

  return (
    <>
      <div className='container-fluid p-4'>
        <div className='tab-content' id='v-pills-tabContent'>
          <div className='row pb-2'>
            <form className='col-lg-9'>
              <div className='row pb-2'>
                <div className='container-fluid d-flex'>
                  <h5 className='text-uppercase flex-fill'>
                    Patient Information
                  </h5>
                </div>
                <div className='d-flex flex-wrap'>
                  {props.data?.map((field, index) => (
                    <div
                      key={`${index}${field.mappingName}`}
                      className='form-field'
                      style={{ marginRight: '10px' }}
                      id={`${field.referralResultId}`}
                    >
                      <div>
                        <label>{field.codeLabel}</label>
                        <div className='info'>{field.textValue}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </form>

            <div className='col-lg-3 vh-100 overflow-auto comment-section'>
              <Legend />
              <div className='d-flex'>
                {!hideComments ? <h5 className='me-3'>Comments</h5> : null}
                <div
                  className='clickable-div'
                  onClick={() => {
                    setHideComments(!hideComments);
                    // this.setState({
                    //   hideComments: !this.state.hideComments,
                    // });
                  }}
                >
                  <i
                    className={`fas fa-angle-${hideComments ? 'down' : 'up'}`}
                  ></i>
                </div>
              </div>
              {!hideComments ? (
                <div className='text-nowrap'>
                  <button
                    disabled={
                      selectedText === '' && !commentLabel.includes('\\n')
                    }
                    className='phcn-btn primary me-3 my-3'
                    onClick={() => {
                      setCommentModalOpen(true);
                      //   this.setState({ commentModalOpen: true });
                    }}
                  >
                    Add Comment
                  </button>
                  <button
                    disabled={
                      selectedText === '' && !commentLabel.includes('\\n')
                    }
                    className='phcn-btn primary me-3 m-3'
                    onClick={() => {
                      handleAddHiglight();
                    }}
                  >
                    Add Highlight
                  </button>
                </div>
              ) : null}
              <div className={`card-container ${hideComments ? 'd-none' : ''}`}>
                {props.commentCards?.map((card, index) => (
                  <CommentCard
                    key={`${index}${Math.floor(Math.random() * 1000)}`}
                    card={card}
                  />
                ))}
              </div>
            </div>
            <Modal
              isOpen={commentModalOpen}
              onRequestClose={() => {
                setCommentModalOpen(false);
                // this.setState({ commentModalOpen: false });
              }}
              style={customStyles}
              contentLabel='Add User Modal'
            >
              <div style={{ maxHeight: '120px', overflow: 'auto' }}>
                <label>Commented Text:</label> {selectedText}
              </div>
              <div className='form-group'>
                <label>Comment</label>
                <textarea
                  style={{ height: '250px', maxHeight: '250px' }}
                  className='form-control noselect'
                  unselectable='on'
                  type='text'
                  name='comment'
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
                />
              </div>
              <div className='d-flex mt-3'>
                <button
                  onClick={() => {
                    setCommentModalOpen(false);
                    // this.setState({ commentModalOpen: false });
                  }}
                  className='btn btn-primary modal-close-button'
                >
                  Cancel
                </button>
                <button
                  style={{ marginLeft: '10px' }}
                  onClick={handleAddComment}
                  className='btn btn-primary modal-confirm-button '
                >
                  Submit
                </button>
              </div>
            </Modal>
          </div>
        </div>
      </div>
    </>
  );
};

export default Section;
